import React from 'react'
import styled from 'styled-components'
import { Navigate } from 'react-router-dom'
import { AuthLayout } from '../../../components/generic/Layouts/AuthLayout'
import { Eyebrow } from '../../../components/generic/ui/Eyebrow'
import { AuthHeading } from '../../../components/generic/ui/Heading'
import { AccentButton } from '../../../components/generic/ui/Button'
import OtpCodeInput from '../../../components/generic/ui/otp-code-input/OtpCodeInput'
import { UseTwoFactorVerifyReturn } from './useTwoFactorVerify'

export const TwoFactorVerifyView: React.FC<UseTwoFactorVerifyReturn> = (p) => {
  if (!p.tempToken) return <Navigate to="/login" replace />
  return (
    <AuthLayout>
      <Eyebrow>AGROLINE / 2FA</Eyebrow>
      <AuthHeading subtitle="הזן את הקוד מאפליקציית האימות שלך">
        אימות<br />דו-שלבי
      </AuthHeading>
      <Form
        onSubmit={(e) => {
          e.preventDefault()
          p.handleVerify()
        }}
      >
        <OtpCodeInput onCodeChange={p.setCode} disabled={p.isLoading} autoFocus />
        <AccentButton type="submit" disabled={!p.isComplete || p.isLoading}>
          {p.isLoading ? 'מאמת...' : 'שמור'}
        </AccentButton>
        <AccentButton type="button" variant="ghost" onClick={p.handleBack}>
          חזרה להתחברות
        </AccentButton>
      </Form>
    </AuthLayout>
  )
}
TwoFactorVerifyView.displayName = 'TwoFactorVerifyView'

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`

export default TwoFactorVerifyView
